// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1c2GJ","title":"Footer_title__3Z4Hm","phone":"Footer_phone__22XKR","address":"Footer_address__2lepg","copy":"Footer_copy__263ig"};